<template>
	<div class="mt6 xs-12 wrap">
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("nature_of_business") }}</div>
		<j-base-select :options="options" v-model="nature" @input="onInput" />
		<j-base-input-text
			v-if="nature == 'Other'"
			class="mt2"
			:placeholder="$t('nature_of_business')"
			size="medium"
			v-model="inputValue"
			@input="onInput"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseSelect from "@/components/JBaseSelect"

export default {
	name: "InputNatureOfBusiness",
	components: {
		JBaseInputText,
		JBaseSelect
	},
	props: {
		value: {
			required: false
		}
	},
	data() {
		return {
			inputValue: "",
			inputType: "",
			nature: "",
			options: [
				{
					name: "Pawn Broker",
					value: "Pawn Broker"
				},
				{
					name: "Director",
					value: "Director"
				},
				{
					name: "Money Exchange",
					value: "Money Exchange"
				},
				{
					name: "Office",
					value: "Office"
				},
				{
					name: "Pawn Shop",
					value: "Pawn Shop"
				},
				{
					name: "Retail",
					value: "Retail"
				},
				{
					name: "Retail Shop",
					value: "Retail Shop"
				},
				{
					name: "Trading",
					value: "Trading"
				},
				{
					name: "Wholesale",
					value: "Wholesale"
				},
				{
					name: "Other",
					value: "Other"
				}
			]
		}
	},

	methods: {
		onInput() {
			this.$emit(
				"input",
				this.nature == "Other" ? this.inputValue : this.nature
			)
		}
	}
}
</script>
